import { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import arrow from "./assets/arrow.png";
import _arrow from "./assets/arrow-white.png";
import Button from "./components/Button.js";
import Dialog from "./components/Dialog.js";
import Footer from "./components/Footer.js";
import Header from "./components/Header.js";
import Home from "./pages/Home.js";
import About from "./pages/About.js";
import Contact from "./pages/Contact.js";
import Gallery from "./pages/Gallery.js";
import AlbumPage from "./pages/AlbumPage.js";
import NoInternetPage from "./pages/NoInternetPage.js";
import PageNotFound from "./pages/PageNotFound.js";
import ScrollTop from "./ScrollTop.js";
import { ThemeContext } from "./ThemeContext.js";
import WelcomePage from "./pages/WelcomePage.js";
import withWidth from "./withWidth.js";

const App = ({ width }) => {
  const [visible, setVisible] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isDialogOpen, setIsDialogOpen] = useState(true);
  const [visited, setVisited] = useState(false);
  const [hide, setHide] = useState(false);
  const [showWelcomePage, setShowWelcomePage] = useState(false);
  const { theme } = useContext(ThemeContext);
  const [scrollButtonBottom, setScrollButtonBottom] = useState(20);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisited");
    if (!hasVisited) {
      setShowWelcomePage(true);
    }
  }, []);

  const handleWelcomeFinish = () => {
    setShowWelcomePage(false);
    localStorage.setItem("hasVisited", "true");
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setVisited(true); // Update state directly
    localStorage.setItem("visited", true);
  };

  useEffect(() => {
    setVisited(localStorage.getItem("visited") === "true");
    const handleScroll = () => {
      if (window.scrollY > 768) setVisible(true);
      else setVisible(false);

      const defaultBottom = 20; // Default bottom position in px
      const minDistanceFromPageBottom = 128; // Minimum distance from the bottom of the page in px

      const pageHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      const scrollY = window.scrollY;

      const distanceToBottom = pageHeight - (scrollY + windowHeight);

      if (distanceToBottom < minDistanceFromPageBottom - defaultBottom) {
        setScrollButtonBottom(minDistanceFromPageBottom - distanceToBottom);
      } else {
        setScrollButtonBottom(defaultBottom);
      }
    };

    handleScroll(); // Re-evaluate trigger when dependencies change
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Update network status
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    // Listen to the online status
    window.addEventListener("online", handleStatusChange);

    // Listen to the offline status
    window.addEventListener("offline", handleStatusChange);

    return () => {
      window.removeEventListener("scroll", handleScroll, { passive: true });
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, [isOnline]);
  return (
    <div id="main" className={theme}>
      {showWelcomePage && <WelcomePage onFinish={handleWelcomeFinish} />}
      {!hide && <Header width={width} />}
      {/* {isDialogOpen && !visited && !showWelcomePage && (
        <Dialog
          title="Notification!"
          message="Please be notified, This website save some of your data for better user experience."
          onClose={closeDialog}
        />
      )} */}
      {isOnline ? (
        <div className="page-view">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} /> {/* Added route for /home */}
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/gallery/:albumName" element={<AlbumPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      ) : (
        <NoInternetPage />
      )}
      {!hide && (
        <>
          <Footer />
          <ScrollTop>
            <Button
              round
              style={{
                transform: visible ? "scale(1)" : "scale(0)",
                bottom: `${scrollButtonBottom}px`,
              }}
              className="scroll-button"
            >
              <img
                alt="scroll"
                className="scroll-img"
                src={theme === "dark" ? _arrow : arrow}
              />
            </Button>
          </ScrollTop>
        </>
      )}
      <ToastContainer
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default withWidth(App);
